import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-piskotki.webp";

export const Route = createFileRoute("/piskotki")({
  head: () => ({
    meta: [
      { title: "Piškotki — kupish.si" },
      { name: "description", content: "Kako kupish.si uporablja piškotke: nujno potrebne piškotke za prijavo in košarico ter anonimne analitične piškotke le z vašim soglasjem." },
      { property: "og:title", content: "Piškotki — kupish.si" },
      { property: "og:description", content: "Kako kupish.si uporablja piškotke: nujno potrebne piškotke za prijavo in košarico ter anonimne analitične piškotke le z vašim soglasjem." },
      { property: "og:url", content: "https://kupish.si/piskotki" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://kupish.si/piskotki" }],
  }),

  component: Page,
});

function Page() {
  return (
    <article className="pb-24">
      <PageHero src={pageCover} alt="Piškotki na kupish.si — minimalističen 3D prikaz piškotka in brskalnika">
        <Link to="/zasebnost" className="text-xs uppercase tracking-[0.18em] text-accent hover:underline">
          ← Pravila o zasebnosti
        </Link>
        <h1 className="font-serif text-4xl md:text-6xl mt-6 leading-[1.05] tracking-tight">
          <span className=" text-accent">Piškotki</span>
        </h1>
        <time className="mt-5 block text-sm text-muted-foreground">Zadnja sprememba: september 2026</time>
      </PageHero>

      <div className="mx-auto max-w-3xl px-6 mt-14 md:mt-20">
        <div className="article-prose">
          <p>
            Za delovanje strani uporabljamo le nujno potrebne piškotke (prijava, košarica). Z vašim
            soglasjem lahko uporabljamo tudi anonimne analitične piškotke za izboljšanje strani.
          </p>
          <h2>Nujni piškotki</h2>
          <ul>
<li><strong>auth</strong> — sejni piškotek za prijavljenega uporabnika (prijava prek e-poštne povezave).</li>
            <li><strong>kupish:cart</strong> — vsebina vaše košarice (localStorage).</li>
            <li><strong>kupish:cookie-consent</strong> — vaša izbira glede piškotkov.</li>
          </ul>
          <h2>Analitika</h2>
          <p>
            Trenutno analitičnih piškotkov ne uporabljamo. Če jih bomo uvedli, jih bomo vključili šele po
            vaši privolitvi.
          </p>
          <h2>Upravljanje</h2>
          <p>
            Privolitev lahko kadarkoli umaknete tako, da v brskalniku počistite piškotke za to spletno stran.
          </p>
        </div>
      </div>
    </article>
  );
}
